import printJS from "lib/print-js";
import { TYRE_LOCATIONS, TYRE_POSITIONS } from "models";
import { PRINT_SIZE } from "utils/common";

import type { CarTyres, QuestionResult, Tyre, VehicleTyre } from "models";

export const getDBBComment = (position: TYRE_POSITIONS, carTyres?: CarTyres) => {
  if (!carTyres) return "";

  switch (position) {
    case TYRE_POSITIONS.CarFrontLeft:
    case TYRE_POSITIONS.StorageFrontLeft:
      return carTyres.dbb_fl_comment;
    case TYRE_POSITIONS.CarFrontRight:
    case TYRE_POSITIONS.StorageFrontRight:
      return carTyres.dbb_fr_comment;
    case TYRE_POSITIONS.CarRearLeft:
    case TYRE_POSITIONS.StorageRearLeft:
      return carTyres.dbb_rl_comment;
    case TYRE_POSITIONS.CarRearRight:
    case TYRE_POSITIONS.StorageRearRight:
      return carTyres.dbb_rr_comment;
    default:
      return "";
  }
};

export const getPositionInitialsDutch = (position: TYRE_POSITIONS) => {
  switch (position) {
    case TYRE_POSITIONS.CarFrontLeft:
    case TYRE_POSITIONS.StorageFrontLeft:
      return "LV";

    case TYRE_POSITIONS.CarFrontRight:
    case TYRE_POSITIONS.StorageFrontRight:
      return "RV";

    case TYRE_POSITIONS.CarRearLeft:
    case TYRE_POSITIONS.StorageRearLeft:
      return "LA";

    case TYRE_POSITIONS.CarRearRight:
    case TYRE_POSITIONS.StorageRearRight:
      return "RA";
    default:
      return "";
  }
};

export const shortenText = (printSize: PRINT_SIZE, text: string | undefined, limit: number) => {
  if (!text) return "";
  if (printSize === PRINT_SIZE.A4) return text;

  if (text.length > limit) return `${text.slice(0, limit).trim()}...`;
  return text;
};

export const handlePrint = () => {
  printJS({
    printable: "dbb_label_content_container",
    type: "html",
    copyStyles: true
  });
};

export type DBBLabel = {
  position: TYRE_POSITIONS;
  profile: number;
  tyre: Tyre;
};

export const convertQuestionResultsToDBBLabels = (questionResults: QuestionResult[]): DBBLabel[] => {
  return questionResults.map(q => (q.tyre ? { position: q.tyre_position, profile: q.tyre_profile, tyre: q.tyre } : null)).filter(tl => tl !== null);
};

export const convertVehicleTyresToDBBLabels = (tyres: VehicleTyre[]): DBBLabel[] => {
  return tyres.map(q => (q.tyre ? { position: q.position, profile: q.profile, tyre: q.tyre } : null)).filter(tl => tl !== null);
};

export const convertCarTyresToDBBLabels = (carTyres?: CarTyres): DBBLabel[] => {
  const tyreLabels: DBBLabel[] = [];

  if (!carTyres) return tyreLabels;
  const isOnCar = carTyres.location === TYRE_LOCATIONS.OnVehicle;

  if (carTyres.front_left_tyre) {
    tyreLabels.push({
      position: isOnCar ? TYRE_POSITIONS.CarFrontLeft : TYRE_POSITIONS.StorageFrontLeft,
      profile: carTyres.fl_profile,
      tyre: carTyres.front_left_tyre
    });
  }

  if (carTyres.front_right_tyre) {
    tyreLabels.push({
      position: isOnCar ? TYRE_POSITIONS.CarFrontRight : TYRE_POSITIONS.StorageFrontRight,
      profile: carTyres.fr_profile,
      tyre: carTyres.front_right_tyre
    });
  }

  if (carTyres.rear_left_tyre) {
    tyreLabels.push({
      position: isOnCar ? TYRE_POSITIONS.CarRearLeft : TYRE_POSITIONS.StorageRearLeft,
      profile: carTyres.rl_profile,
      tyre: carTyres.rear_left_tyre
    });
  }

  if (carTyres.rear_right_tyre) {
    tyreLabels.push({
      position: isOnCar ? TYRE_POSITIONS.CarRearRight : TYRE_POSITIONS.StorageRearRight,
      profile: carTyres.rr_profile,
      tyre: carTyres.rear_right_tyre
    });
  }

  return tyreLabels;
};
